export default "__VITE_ASSET__DiO_nOnL__"